import React from 'react';
import { Link } from 'react-router-dom';
import { NEWS_CATEGORIES, buildNewsHubPath } from '../lib/newsPublications';

const NewsFilterTabs = ({ activeFilter = 'all' }) => (
  <nav
    className="flex flex-wrap gap-2 sm:gap-3"
    aria-label="Фильтр публикаций"
  >
    {NEWS_CATEGORIES.map((category) => {
      const isActive = category.id === activeFilter;
      return (
        <Link
          key={category.id}
          to={buildNewsHubPath(category.id)}
          className={`inline-flex items-center rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
            isActive
              ? 'border-accent bg-accent text-accent-foreground shadow-sm'
              : 'border-border/60 bg-card text-foreground/80 hover:border-accent/40 hover:text-accent'
          }`}
          aria-current={isActive ? 'page' : undefined}
        >
          {category.label}
        </Link>
      );
    })}
  </nav>
);

export default NewsFilterTabs;
